export default __webpack_public_path__ + "static/media/girl_on_bike.c1d78413.png";